import React, { useState, useEffect, useRef } from 'react';
import './App.css';

function App() {
    const containerRef = useRef(null);
    const [cursorPos, setCursorPos] = useState({ top: 0, left: 0 });
    const [careersText, setCareersText] = useState("Careers");

    const handleCareersClick = () => {
        setCareersText("Coming Soon (200k+ starting)");
    };

    const setRandomPosition = () => {
        const container = containerRef.current;
        if (container) {
            const { width, height } = container.getBoundingClientRect();
            const newLeft = Math.random() * (width - 32);
            const newTop = Math.random() * (height - 32);
            setCursorPos({ top: newTop, left: newLeft });
        }
    };

    useEffect(() => {
        setRandomPosition();
        const interval = setInterval(setRandomPosition, 30000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="grid-container" ref={containerRef}>
            <div className="cursor" style={{ top: cursorPos.top, left: cursorPos.left }}></div>
            <div className="left-col">
                <div className="branding">
                    <h1>Carrie.ai</h1>
                    <p>Building in<br /> SF & NYC</p>
                </div>
                <div className="footer-links">
                    <ul>
                        <li onClick={handleCareersClick} style={{ cursor: "pointer" }}>{careersText}</li>
                        <li>Privacy</li>
                        <li>Terms</li>
                    </ul>
                </div>
            </div>
            <div className="main-col">
                <p className="intro">
                    <b>The future of computer use doesn’t involve screenshots.</b>
                    <br></br>
                    We’re quietly building the next generation of AI agents—powerful, intuitive, and invisible.
                </p>
                <p className="mission">
                    We're reimagining the desktop for AI. Our mission is to build cutting-edge AI apps that integrate seamlessly with macOS and Windows, empowering intelligent systems to work alongside humans.
                    <br></br>
                    <br></br>
                    Our first product is a suite of smart tools designed to supercharge productivity—paving the way for our ultimate vision: an AI-powered OS that redefines human-machine interaction.
                </p>
                <p className="cta">
                    <a href="mailto:info@stealthagents.io">Reach Out</a>
                </p>
            </div>
        </div>
    );
}

export default App;
